//#region Imports
import CloseIcon from '@mui/icons-material/Close';
import { Backdrop, Box, Button, Dialog, DialogContent, DialogTitle, MenuItem, TextField, Typography } from '@mui/material';
import CircularProgress from "@mui/material/CircularProgress";
import Select from "@mui/material/Select";
import jsPDF from 'jspdf';
import React, { useEffect, useRef, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import BasicTable from '../../../components/basicTable/basicTable';
import Map from '../../../components/maps/map';
import RemainingTime from '../../../components/time/remainingTime';
import orange_Circle from '../../../images/blueCircle.png';
import orange from '../../../images/orange_Circle.png';

import eOpsLogo from '../../../images/eops.png';
import pdf from '../../../images/pdf.png';
import redCircle from '../../../images/red_circle.png';
import triangleoff from '../../../images/triangle-off.png';
import { convertDateYYYYMMDD, convertDatewithTime, subdivisionName } from '../../../services/Functions';
import { buttonStyle, internalIconStyles, tableStyle } from '../../../style/common';
//#endregion
import DialogActions from '@mui/material/DialogActions';
import closeIcon from '../../../images/close_icon.png';
import closeIconWhite from '../../../images/close_icon_white.png';
import { wfsBaseUrl } from '../../../network/urls';
import { fetchPaginatedAllComplaints } from '../../../features/powerComplaints/getComplaintSlice';
import cellIcon from '../../../images/cellicon.png'
import eopsIcons from '../../../images/eopsicon.png'
import callCenter from '../../../images/callcenter.png'
import PrintIcon from '@mui/icons-material/Print';
import pencilIcon from '../../../images/pencil.png';

const DisplayComplaintsGIS = () => {
    const { code, hierarchy, token, permissions, name, roleName, userId,wmsPrivateToken } = useSelector((state) => state.auth)
    const dispatch = useDispatch();
    const { data: geoJSON } = useSelector((state) => state.geoJson)
    const { data: result1 } = useSelector((state) => state.feederStatus)
    const { pageSize: complaintsPageSize, pageNumber: complaintsPageNumber, subDivisionCode: complaintsSubDivisionCode, dateFrom: complaintsDateFrom, dateTo: complaintsDateTo } = useSelector((state) => state.allComplaints)
    const { data: mdmToken } = useSelector((state) => state.authorization);
    // const [mdmToken, setMdmToken] = useState(null);
    const [connections, setConnections] = useState();
    const [complaints, setComplaints] = useState([])
    const [showComplaintForm, setShowComplaintForm] = useState(false);

    const [showPendingComplaint, setShowPendingComplaint] = useState(false);
    const [selectedLineman, setSelectedLineman] = useState('');
    const [userIds, setUserIds] = useState([]);
    const [linemanDetails, setLinemanDetails] = useState([]);
    const [onPressComplaint, setOnPressComplaint] = useState()
    const [Priority, setPriority] = useState("1")
    const [powerComplaintsToDataGrid, setPowerComplaintsToDataGrid] = useState([]);

    const [pendingComplaints, setPendingComplaints] = useState()
    const [allocatedComplaints, setAllocatedComplaints] = useState()
    const [workingComplaints, setWorkingComplaints] = useState()
    const [onholdComplaints, setOnHoldComplaints] = useState()
    const [escalatedComplaints, setEscalatedComplaints] = useState()
    const [resolvedComplaints, setResolvedComplaints] = useState()
    const [totalComplaints, setTotalComplaints] = useState()
    const [rowData, setRowData] = useState()

    const [pendingStats, setPendingStats] = useState()
    const [allocatedStats, setAllocatedStats] = useState()
    const [onholdStats, setOnholdStats] = useState()
    const [workingStats, setWorkingStats] = useState()
    const [escalatedStats, setEscalatedStats] = useState()
    const [resolvedStats, setResolvedStats] = useState()
    const [allComplaintsState, setAllComplaintsState] = useState([])

    const [editingRowId, setEditingRowId] = useState(null);

    const [isHovered, setIsHovered] = useState(false);

    const [checkEdit, setCheckEdit] = useState(false)
    const [viewBackdrop, setViewBackdrop] = useState(false);

    const statsTableRef = useRef();

    const [statsValue, setStatsValue] = useState()

    const statusNames = [
        'Pending',
        'Allocated',
        'Onhold',
        'Escalated',
        'Resolved',
        'Total',
    ];
    const [status, setStatus] = useState("Resolved");
    const [remarkStatus, setRemarkStatus] = useState("Resolved");
    const [remarks, setRemarks] = useState([])
    const [otherComplaints, setOtherComplaints] = useState()

    const subDivisions = JSON.parse(window.localStorage.getItem('subDivisions'));
    const [selectedMarker, setSelectedMarker] = useState(null); // State for selected complaint or connection
    const [selectedMarker2, setSelectedMarker2] = useState(null); // State for selected complaint or connection

    const [open, setOpen] = useState(false); // State for popup visibility

    const today = new Date(); // Setting a specific date for testing
    const yesterday = new Date(today);
    yesterday.setDate(today.getDate() - 1);

    const yesterdayDate = yesterday.toISOString().split('T')[0];
    const [hoveredIndex, setHoveredIndex] = useState(null);

    const handleOpenPopup = (item) => {
        setSelectedMarker(item);

        setOnPressComplaint(item)
        setShowComplaintForm(true)

    };

    const handleClosePopup = () => {
        setOpen(false);
        setSelectedMarker(null);
    };

    const handleClose = () => {
        setOpen(false);
        setSelectedMarker(null);
    };

  
    let areaCode = ''
    if (hierarchy !== 52) {
        areaCode = '15171'
    } else {
        areaCode = code.slice(0, 5)
    }

    useEffect(() => {
        // getMDMToken();
    }, []);

    const currentDate = new Date();

    const getShiftIdByTime = () => {
        const currentTime = new Date();
        const hours = currentTime.getHours();

        if (hours >= 6 && hours < 14) {
            return 1; // Shift 1: 6am - 2pm
        } else if (hours >= 14 && hours < 22) {
            return 2; // Shift 2: 2pm - 10pm
        } else {
            return 3; // Shift 3: 10pm - 6am
        }
    };

    const filterLinemanByShift = (linemanData, shiftId) => {
        return linemanData.filter(lineman => lineman.shiftId === shiftId);
    };


    useEffect(() => {
        if (wmsPrivateToken) {
            const getLineDataComplaints = async () => {
                const myHeaders = new Headers();
                myHeaders.append("Authorization", wmsPrivateToken);
                const formdata = new FormData();
                formdata.append("SubDivisionCode", hierarchy != 52 ? '15171' : code);
                const requestOptions = {
                    method: "POST",
                    headers: myHeaders,
                    body: formdata,
                    redirect: "follow"
                };

                await fetch(wfsBaseUrl + "api/UserInfo/GetEOpsLMUserInfo", requestOptions)
                    .then((response) => response.json())
                    .then(async (result) => {
                        const currentShiftId = getShiftIdByTime();
                        const filteredLineman = filterLinemanByShift(result.Data, currentShiftId);
                        setUserIds(filteredLineman)

                    })
                    .catch((error) => console.error(error));
            }
            getLineDataComplaints()
        }
    }, [wmsPrivateToken])

    useEffect(() => {
        if (wmsPrivateToken) {
            const getDataStats = async () => {
                const myHeaders = new Headers();
                myHeaders.append("Authorization", wmsPrivateToken);

                const dateObject = new Date(currentDate);
                const formattedDate = dateObject.toISOString().split('T')[0];

                const formdata = new FormData();
                formdata.append("officeCode", hierarchy !== 52 ? '15' : code);
                formdata.append("dateFrom", formattedDate);
                formdata.append("dateTo", formattedDate);
                formdata.append("pageSize", "9999");
                formdata.append("pageNumber", "1");

                const requestOptions = {
                    method: "POST",
                    headers: myHeaders,
                    body: formdata,
                    redirect: "follow"
                };

                try {
                    const response = await fetch(wfsBaseUrl + "api/Complaints/GetComplaintForReportsOfficeWise", requestOptions);
                    const result = await response.json();

                    let lineComplaints = result.Data.requestedComplaint.filter((item) => item.complaintNature == 'Line Complaints')


                    let pendingComplaints = [];
                    let allocatedComplaints = [];
                    let workingComplaints = [];
                    let onholdComplaints = [];
                    let escalatedComplaints = [];
                    let resolvedComplaints = [];
                    let otherComplaints = [];
                    let totalComplaint = 0;
                    let allComplaints = []; // Array to hold all complaints

                    const formatComplaintTime = (dateString) => {
                        const dateObj = new Date(dateString);
                        const hours = String(dateObj.getHours()).padStart(2, '0');
                        const minutes = String(dateObj.getMinutes()).padStart(2, '0');
                        return `${hours}:${minutes}`;
                    };

                    lineComplaints.forEach(complaint => {
                        if (complaint.registeredAt) {
                            complaint.registeredAt = formatComplaintTime(complaint.registeredAt);
                        }
                        if (complaint.allocationDateTime) {
                            complaint.allocationDateTime = formatComplaintTime(complaint.allocationDateTime);
                        }
                        if (complaint.modificationDateTime) {
                            complaint.modificationDateTime = formatComplaintTime(complaint.modificationDateTime);
                        }

                        // Push complaint to the allComplaints array
                        allComplaints.push(complaint);

                        switch (complaint.status) {
                            case 'Pending':
                                pendingComplaints.push(complaint);
                                break;
                            case 'Allocated':
                                allocatedComplaints.push(complaint);
                                break;
                            case 'Working':
                                workingComplaints.push(complaint);
                                break;
                            case 'onhold':
                                onholdComplaints.push(complaint);
                                break;
                            case 'Escalated':
                                escalatedComplaints.push(complaint);
                                break;
                            case 'Resolved':
                                resolvedComplaints.push(complaint);
                                break;
                            default:
                                otherComplaints.push(complaint);
                                break;
                        }
                        totalComplaint++;  // Increment totalComplaint
                    });

                    setOtherComplaints(otherComplaints);
                    setPendingStats(pendingComplaints);
                    setAllocatedStats(allocatedComplaints);
                    setOnholdStats(onholdComplaints);
                    setEscalatedStats(escalatedComplaints);
                    setWorkingStats(workingComplaints);
                    setResolvedStats(resolvedComplaints);
                    setTotalComplaints(totalComplaint);  // Update total complaints state
                    setAllComplaintsState(allComplaints); // Update all complaints array state

                } catch (error) {
                    console.error(error);
                }
            };

            getDataStats();
        }
    }, [wmsPrivateToken]);

    const getDataStats = async (value) => {
        setStatsValue(value);
        const myHeaders = new Headers();
        myHeaders.append("Authorization", wmsPrivateToken);

        const formattedDate = new Date(currentDate).toISOString().split('T')[0];
        const formdata = new FormData();
        formdata.append("officeCode", hierarchy !== 52 ? '15' : code);
        formdata.append("dateFrom", formattedDate);
        formdata.append("dateTo", formattedDate);
        formdata.append("pageSize", "9999");
        formdata.append("pageNumber", "1");

        const requestOptions = {
            method: "POST",
            headers: myHeaders,
            body: formdata,
            redirect: "follow"
        };

        try {
            const response = await fetch(wfsBaseUrl + "api/Complaints/GetComplaintForReportsOfficeWise", requestOptions);
            const result = await response.json();
            let lineComplaints = result.Data.requestedComplaint.filter((item) => item.complaintNature == 'Line Complaints')
            let pendingComplaints = [];
            let allocatedComplaints = [];
            let workingComplaints = [];
            let onholdComplaints = [];
            let escalatedComplaints = [];
            let resolvedComplaints = [];
            let otherComplaints = [];
            let allComplaints = []; // Array to hold all complaints

            const formatComplaintTime = (dateString) => {
                const dateObj = new Date(dateString);
                const hours = String(dateObj.getHours()).padStart(2, '0');
                const minutes = String(dateObj.getMinutes()).padStart(2, '0');
                return `${hours}:${minutes}`;
            };

            lineComplaints.forEach((complaint) => {
                // Format time fields
                if (complaint.registeredAt) {
                    complaint.registeredAt = formatComplaintTime(complaint.registeredAt);
                }
                if (complaint.allocationDateTime) {
                    complaint.allocationDateTime = formatComplaintTime(complaint.allocationDateTime);
                }
                if (complaint.modificationDateTime) {
                    complaint.modificationDateTime = formatComplaintTime(complaint.modificationDateTime);
                }
                allComplaints.push(complaint);

                switch (complaint.status) {
                    case 'Pending':
                        pendingComplaints.push(complaint);
                        break;
                    case 'Allocated':
                        allocatedComplaints.push(complaint);
                        break;
                    case 'Working':
                        workingComplaints.push(complaint);
                        break;
                    case 'onhold':
                        onholdComplaints.push(complaint);
                        break;
                    case 'Escalated':
                        escalatedComplaints.push(complaint);
                        break;
                    case 'Resolved':
                        resolvedComplaints.push(complaint);
                        break;
                    default:
                        otherComplaints.push(complaint);
                        break;
                }
            });

            setShowPendingComplaint(true);
            setPendingStats(pendingComplaints);
            setAllocatedStats(allocatedComplaints);
            setOnholdStats(onholdComplaints);
            setEscalatedStats(escalatedComplaints);
            setWorkingStats(workingComplaints);
            setResolvedStats(resolvedComplaints);
            setAllComplaintsState(allComplaints);
        } catch (error) {
            console.error(error);
        }
    };


    const getAPMSCoordinates = async (mdmToken, areaCode) => {
        try {

            const myHeaders = new Headers();
            myHeaders.append("Accept", "application/json");
            myHeaders.append("privatekey", mdmToken);

            const formdata = new FormData();
            formdata.append("organization_code", areaCode);

            const requestOptions = {
                method: "POST",
                headers: myHeaders,
                body: formdata,
                redirect: "follow"
            };

            await fetch("https://api.mdm.pitc.com.pk/api/get_apms_status", requestOptions)
                .then((response) => response.json())
                .then((result) => {
                    if (result.status) {
                        setConnections(result.data);
                    }
                })
                .catch((error) => console.error(error));

        } catch (error) {
            console.error('Error getting APMS coordinates:', error);
        }
    };

    useEffect(() => {
        if (mdmToken) {
            getAPMSCoordinates(mdmToken.privatekey, areaCode)

            const intervalId = setInterval(() => {
                getAPMSCoordinates(mdmToken.privatekey, areaCode);
            }, 60000);

            return () => clearInterval(intervalId);
        }
    }, [mdmToken])

    const handleSubmit = (complaint) => {
        setSelectedMarker(complaint)
        setShowComplaintForm(true)
    }

    const [data1, setData1] = useState("")
    const handleSubmit2 = (details) => {
        // setData1(details)
    }
    const [counter, setCounter] = useState(0);

    const tblColumns = [
        { field: "eOpsTrackingId", headerName: 'Complaint ID', align: 'center', sortable: false, filterable: false, headerStyle: tableStyle.headerStyle, headerCellStyle: tableStyle.headerCellStyle, rowCellStyle: tableStyle.rowCellStyle },
        { field: "allocationDateTime", headerName: 'Registered At', align: 'center', sortable: false, filterable: false, headerStyle: tableStyle.headerStyle, headerCellStyle: tableStyle.headerCellStyle, rowCellStyle: tableStyle.rowCellStyle },
        { field: "address", headerName: 'Address', align: 'left', sortable: false, filterable: false, headerStyle: tableStyle.headerStyle, headerCellStyle: tableStyle.headerCellStyle, rowCellStyle: tableStyle.rowCellStyle },
        { field: "complaintDescription", headerName: 'Complaint Description', align: 'left', sortable: false, filterable: false, headerStyle: tableStyle.headerStyle, headerCellStyle: tableStyle.headerCellStyle, rowCellStyle: tableStyle.rowCellStyle },

    ]

    const tblPendingComplaints = [
        { field: "eOpsTrackingId", headerName: 'Complaint ID', align: 'left', sortable: false, filterable: false, headerStyle: tableStyle.headerStyle, headerCellStyle: tableStyle.headerCellStyle, rowCellStyle: tableStyle.rowCellStyle },
        { field: "refNo", headerName: 'Ref No.', align: 'left', sortable: false, filterable: false, headerStyle: tableStyle.headerStyle, headerCellStyle: tableStyle.headerCellStyle, rowCellStyle: tableStyle.rowCellStyle },
        { field: "registeredAt", headerName: 'Time', align: 'left', sortable: false, filterable: false, headerStyle: tableStyle.headerStyle, headerCellStyle: tableStyle.headerCellStyle, rowCellStyle: tableStyle.rowCellStyle },
        { field: "name", headerName: 'Name', align: 'left', sortable: false, filterable: false, headerStyle: tableStyle.headerStyle, headerCellStyle: tableStyle.headerCellStyle, rowCellStyle: tableStyle.rowCellStyle }, // Updated alignment
        { field: "address", headerName: 'Address', align: 'left', sortable: false, filterable: false, headerStyle: tableStyle.headerStyle, headerCellStyle: tableStyle.headerCellStyle, rowCellStyle: tableStyle.rowCellStyle },
        { field: "complaintType", headerName: 'Complaint Type', align: 'left', sortable: false, filterable: false, headerStyle: tableStyle.headerStyle, headerCellStyle: tableStyle.headerCellStyle, rowCellStyle: tableStyle.rowCellStyle },
    ];

    const tblAllocatedComplaints = [
        { field: "eOpsTrackingId", headerName: 'Complaint ID', align: 'left', sortable: false, filterable: false, headerStyle: tableStyle.headerStyle, headerCellStyle: tableStyle.headerCellStyle, rowCellStyle: tableStyle.rowCellStyle },
        { field: "refNo", headerName: 'Ref No.', align: 'left', sortable: false, filterable: false, headerStyle: tableStyle.headerStyle, headerCellStyle: tableStyle.headerCellStyle, rowCellStyle: tableStyle.rowCellStyle },
        { field: "registeredAt", headerName: 'Time', align: 'left', sortable: false, filterable: false, headerStyle: tableStyle.headerStyle, headerCellStyle: tableStyle.headerCellStyle, rowCellStyle: tableStyle.rowCellStyle },
        { field: "name", headerName: 'Name', align: 'left', sortable: false, filterable: false, headerStyle: tableStyle.headerStyle, headerCellStyle: tableStyle.headerCellStyle, rowCellStyle: tableStyle.rowCellStyle },
        { field: "address", headerName: 'Address', align: 'left', sortable: false, filterable: false, headerStyle: tableStyle.headerStyle, headerCellStyle: tableStyle.headerCellStyle, rowCellStyle: tableStyle.rowCellStyle },
        { field: "complaintType", headerName: 'Complaint Type', align: 'left', sortable: false, filterable: false, headerStyle: tableStyle.headerStyle, headerCellStyle: tableStyle.headerCellStyle, rowCellStyle: tableStyle.rowCellStyle },
        {
            field: "userFullName", headerName: 'Assigned to', align: 'left', sortable: false, filterable: false, headerStyle: tableStyle.headerStyle, headerCellStyle: tableStyle.headerCellStyle, rowCellStyle: tableStyle.rowCellStyle, renderCell: (params) => {
                const isEditing = editingRowId === params.eOpsTrackingId; // Check if this row is being edited
                return (
                    <div style={{ display: 'flex' }}>
                        {
                            isEditing ? (
                                <Select
                                    style={{ backgroundColor: '#f3f4f6', padding: '10px', borderRadius: '5px', border: '1px solid grey', height: 30, width: 150 }}
                                    onChange={(event) => {

                                        const myHeaders = new Headers();
                                        myHeaders.append("Authorization", wmsPrivateToken);

                                        const formdata = new FormData();
                                        formdata.append("AllocatedTo", event.target.value);
                                        formdata.append("Priority", "1");
                                        formdata.append("AllocatedBy", userId);
                                        formdata.append("EOpsTrackingId", params.eOpsTrackingId);

                                        const requestOptions = {
                                            method: "POST",
                                            headers: myHeaders,
                                            body: formdata,
                                            redirect: "follow"
                                        };

                                        fetch(wfsBaseUrl + "api/Complaints/CompaintAllocation", requestOptions)
                                            .then((response) => response.json())
                                            .then(async (result) => {

                                                setEditingRowId(false)
                                                const myHeaders = new Headers();
                                                myHeaders.append("Authorization", wmsPrivateToken);

                                                const formattedDate = new Date(currentDate).toISOString().split('T')[0];
                                                const formdata = new FormData();
                                                formdata.append("officeCode", hierarchy !== 52 ? '15' : code);
                                                formdata.append("dateFrom", yesterdayDate);
                                                formdata.append("dateTo", formattedDate);
                                                formdata.append("pageSize", "9999");
                                                formdata.append("pageNumber", "1");

                                                const requestOptions = {
                                                    method: "POST",
                                                    headers: myHeaders,
                                                    body: formdata,
                                                    redirect: "follow"
                                                };

                                                try {
                                                    const response = await fetch(wfsBaseUrl + "api/Complaints/GetComplaintForReportsOfficeWise", requestOptions);
                                                    const result = await response.json();
                                                    let lineComplaints = result.Data.requestedComplaint.filter((item) => item.complaintNature == 'Line Complaints')
                                                    let pendingComplaints = [];
                                                    let allocatedComplaints = [];
                                                    let workingComplaints = [];
                                                    let onholdComplaints = [];
                                                    let escalatedComplaints = [];
                                                    let resolvedComplaints = [];
                                                    let otherComplaints = [];
                                                    let allComplaints = []; // Array to hold all complaints

                                                    const formatComplaintTime = (dateString) => {
                                                        const dateObj = new Date(dateString);
                                                        const hours = String(dateObj.getHours()).padStart(2, '0');
                                                        const minutes = String(dateObj.getMinutes()).padStart(2, '0');
                                                        return `${hours}:${minutes}`;
                                                    };

                                                    lineComplaints.forEach((complaint) => {
                                                        // Format time fields
                                                        if (complaint.registeredAt) {
                                                            complaint.registeredAt = formatComplaintTime(complaint.registeredAt);
                                                        }
                                                        if (complaint.allocationDateTime) {
                                                            complaint.allocationDateTime = formatComplaintTime(complaint.allocationDateTime);
                                                        }
                                                        if (complaint.modificationDateTime) {
                                                            complaint.modificationDateTime = formatComplaintTime(complaint.modificationDateTime);
                                                        }
                                                        allComplaints.push(complaint);

                                                        switch (complaint.status) {
                                                            case 'Pending':
                                                                pendingComplaints.push(complaint);
                                                                break;
                                                            case 'Allocated':
                                                                allocatedComplaints.push(complaint);
                                                                break;
                                                            case 'Working':
                                                                workingComplaints.push(complaint);
                                                                break;
                                                            case 'onhold':
                                                                onholdComplaints.push(complaint);
                                                                break;
                                                            case 'Escalated':
                                                                escalatedComplaints.push(complaint);
                                                                break;
                                                            case 'Resolved':
                                                                resolvedComplaints.push(complaint);
                                                                break;
                                                            default:
                                                                otherComplaints.push(complaint);
                                                                break;
                                                        }
                                                    });

                                                    setShowPendingComplaint(true);
                                                    setPendingStats(pendingComplaints);
                                                    setAllocatedStats(allocatedComplaints);
                                                    setOnholdStats(onholdComplaints);
                                                    setEscalatedStats(escalatedComplaints);
                                                    setWorkingStats(workingComplaints);
                                                    setResolvedStats(resolvedComplaints);
                                                    setAllComplaintsState(allComplaints);
                                                } catch (error) {
                                                    console.error(error);
                                                }
                                            })
                                            .catch((error) => console.error(error));
                                    }}

                                    displayEmpty
                                    fullWidth
                                >
                                    <MenuItem value="">Select</MenuItem>
                                    {userIds.map((item) => (
                                        <MenuItem value={item.userId} key={item.userId}>
                                            {item.userFullName}
                                        </MenuItem>
                                    ))}
                                </Select>
                            ) : (
                                <p>{params.userFullName}</p>
                            )
                        }
                        <img
                            src={pencilIcon}
                            alt="edit"
                            width={17.5}
                            height={17.5}
                            style={{ cursor: 'pointer', marginLeft: 10 }}
                            onClick={() => {
                                setEditingRowId(isEditing ? null : params.eOpsTrackingId)
                            }} // Toggle edit mode for this row
                        />
                    </div>
                );
            }
        },
        { field: "allocationDateTime", headerName: 'Assigned @', align: 'left', sortable: false, filterable: false, headerStyle: tableStyle.headerStyle, headerCellStyle: tableStyle.headerCellStyle, rowCellStyle: tableStyle.rowCellStyle },
    ]

    const tblOnHoldComplaints = [
        { field: "eOpsTrackingId", headerName: 'Complaint ID', align: 'left', sortable: false, filterable: false, headerStyle: tableStyle.headerStyle, headerCellStyle: tableStyle.headerCellStyle, rowCellStyle: tableStyle.rowCellStyle },
        { field: "refNo", headerName: 'Ref No.', align: 'left', sortable: false, filterable: false, headerStyle: tableStyle.headerStyle, headerCellStyle: tableStyle.headerCellStyle, rowCellStyle: tableStyle.rowCellStyle },
        { field: "registeredAt", headerName: 'Time', align: 'left', sortable: false, filterable: false, headerStyle: tableStyle.headerStyle, headerCellStyle: tableStyle.headerCellStyle, rowCellStyle: tableStyle.rowCellStyle },
        { field: "name", headerName: 'Name', align: 'left', sortable: false, filterable: false, headerStyle: tableStyle.headerStyle, headerCellStyle: tableStyle.headerCellStyle, rowCellStyle: tableStyle.rowCellStyle },
        { field: "address", headerName: 'Address', align: 'left', sortable: false, filterable: false, headerStyle: tableStyle.headerStyle, headerCellStyle: tableStyle.headerCellStyle, rowCellStyle: tableStyle.rowCellStyle },
        { field: "complaintType", headerName: 'Complaint Type', align: 'left', sortable: false, filterable: false, headerStyle: tableStyle.headerStyle, headerCellStyle: tableStyle.headerCellStyle, rowCellStyle: tableStyle.rowCellStyle },
        { field: "linemanRemarks", headerName: 'Holding Reason', align: 'left', sortable: false, filterable: false, headerStyle: tableStyle.headerStyle, headerCellStyle: tableStyle.headerCellStyle, rowCellStyle: tableStyle.rowCellStyle },
    ]

    const tblEscalatedComplaints = [
        { field: "eOpsTrackingId", headerName: 'Complaint ID', align: 'left', sortable: false, filterable: false, headerStyle: tableStyle.headerStyle, headerCellStyle: tableStyle.headerCellStyle, rowCellStyle: tableStyle.rowCellStyle },
        { field: "refNo", headerName: 'Ref No.', align: 'left', sortable: false, filterable: false, headerStyle: tableStyle.headerStyle, headerCellStyle: tableStyle.headerCellStyle, rowCellStyle: tableStyle.rowCellStyle },
        { field: "registeredAt", headerName: 'Time', align: 'left', sortable: false, filterable: false, headerStyle: tableStyle.headerStyle, headerCellStyle: tableStyle.headerCellStyle, rowCellStyle: tableStyle.rowCellStyle },
        { field: "name", headerName: 'Name', align: 'left', sortable: false, filterable: false, headerStyle: tableStyle.headerStyle, headerCellStyle: tableStyle.headerCellStyle, rowCellStyle: tableStyle.rowCellStyle },
        { field: "address", headerName: 'Address', align: 'left', sortable: false, filterable: false, headerStyle: tableStyle.headerStyle, headerCellStyle: tableStyle.headerCellStyle, rowCellStyle: tableStyle.rowCellStyle },
        { field: "complaintType", headerName: 'Complaint Type', align: 'left', sortable: false, filterable: false, headerStyle: tableStyle.headerStyle, headerCellStyle: tableStyle.headerCellStyle, rowCellStyle: tableStyle.rowCellStyle },
        { field: "escalatedTo", headerName: 'Escalated to', align: 'left', sortable: false, filterable: false, headerStyle: tableStyle.headerStyle, headerCellStyle: tableStyle.headerCellStyle, rowCellStyle: tableStyle.rowCellStyle },

    ]

    const tblResolvedComplaints = [
        { field: "eOpsTrackingId", headerName: 'Complaint ID', align: 'left', sortable: false, filterable: false, headerStyle: tableStyle.headerStyle, headerCellStyle: tableStyle.headerCellStyle, rowCellStyle: tableStyle.rowCellStyle },
        { field: "refNo", headerName: 'Ref No.', align: 'left', sortable: false, filterable: false, headerStyle: tableStyle.headerStyle, headerCellStyle: tableStyle.headerCellStyle, rowCellStyle: tableStyle.rowCellStyle },
        { field: "registeredAt", headerName: 'Time', align: 'left', sortable: false, filterable: false, headerStyle: tableStyle.headerStyle, headerCellStyle: tableStyle.headerCellStyle, rowCellStyle: tableStyle.rowCellStyle },
        { field: "name", headerName: 'Name', align: 'left', sortable: false, filterable: false, headerStyle: tableStyle.headerStyle, headerCellStyle: tableStyle.headerCellStyle, rowCellStyle: tableStyle.rowCellStyle },
        { field: "address", headerName: 'Address', align: 'left', sortable: false, filterable: false, headerStyle: tableStyle.headerStyle, headerCellStyle: tableStyle.headerCellStyle, rowCellStyle: tableStyle.rowCellStyle },
        { field: "complaintType", headerName: 'Complaint Type', align: 'left', sortable: false, filterable: false, headerStyle: tableStyle.headerStyle, headerCellStyle: tableStyle.headerCellStyle, rowCellStyle: tableStyle.rowCellStyle },
        { field: "userFullName", headerName: 'Resolved By', align: 'left', sortable: false, filterable: false, headerStyle: tableStyle.headerStyle, headerCellStyle: tableStyle.headerCellStyle, rowCellStyle: tableStyle.rowCellStyle },
        { field: "modificationDateTime", headerName: 'Resolved Time', align: 'left', sortable: false, filterable: false, headerStyle: tableStyle.headerStyle, headerCellStyle: tableStyle.headerCellStyle, rowCellStyle: tableStyle.rowCellStyle },

    ]

    const tblTotalComplaints = [
        { field: "eOpsTrackingId", headerName: 'Complaint ID', align: 'left', sortable: false, filterable: false, headerStyle: tableStyle.headerStyle, headerCellStyle: tableStyle.headerCellStyle, rowCellStyle: tableStyle.rowCellStyle },
        { field: "refNo", headerName: 'Ref No.', align: 'left', sortable: false, filterable: false, headerStyle: tableStyle.headerStyle, headerCellStyle: tableStyle.headerCellStyle, rowCellStyle: tableStyle.rowCellStyle },
        { field: "registeredAt", headerName: 'Time', align: 'left', sortable: false, filterable: false, headerStyle: tableStyle.headerStyle, headerCellStyle: tableStyle.headerCellStyle, rowCellStyle: tableStyle.rowCellStyle },
        { field: "name", headerName: 'Name', align: 'left', sortable: false, filterable: false, headerStyle: tableStyle.headerStyle, headerCellStyle: tableStyle.headerCellStyle, rowCellStyle: tableStyle.rowCellStyle },
        { field: "address", headerName: 'Address', align: 'left', sortable: false, filterable: false, headerStyle: tableStyle.headerStyle, headerCellStyle: tableStyle.headerCellStyle, rowCellStyle: tableStyle.rowCellStyle },
        { field: "complaintType", headerName: 'Complaint Type', align: 'left', sortable: false, filterable: false, headerStyle: tableStyle.headerStyle, headerCellStyle: tableStyle.headerCellStyle, rowCellStyle: tableStyle.rowCellStyle },
        { field: "modificationDateTime", headerName: 'Last Modification Time', align: 'left', sortable: false, filterable: false, headerStyle: tableStyle.headerStyle, headerCellStyle: tableStyle.headerCellStyle, rowCellStyle: tableStyle.rowCellStyle },

    ]

    useEffect(() => {
        const getUserWithAllocatedComplaintsBySubDivision = async () => {
            const myHeaders = new Headers();
            myHeaders.append("Authorization", wmsPrivateToken);
            const formdata = new FormData();
            formdata.append("SubDivisionCode", hierarchy === 52 ? code : "15171");
            formdata.append("Status", "Allocated");
            const requestOptions = {
                method: "POST",
                headers: myHeaders,
                body: formdata,
                redirect: "follow"
            };
            await fetch(wfsBaseUrl + "api/Complaints/GetUserWithAllocatedComplaintsBySubDivision", requestOptions)
                .then((response) => response.json())
                .then((result) => {
                    setLinemanDetails(result.Data)
                })
                .catch((error) => console.error(error));
        }
        getUserWithAllocatedComplaintsBySubDivision()
    }, [])

    const handleLinemanChange = (event) => {
        setSelectedLineman(event.target.value);

        const foundLineman = linemanDetails.find((lineman) => lineman.userId === event.target.value);

        if (foundLineman && foundLineman.allocatedComplaints) {
            const formattedComplaints = foundLineman.allocatedComplaints.map((complaint) => {
                return {
                    ...complaint,
                    allocationDateTime: convertDatewithTime(complaint.allocationDateTime)  // Example format
                };
            })
            setPowerComplaintsToDataGrid(formattedComplaints);
        } else {
            setPowerComplaintsToDataGrid('');
        }
    };


    const handlePriority = (event) => {
        setPriority(event.target.value);
    };
    const onClose = () => {
        setShowComplaintForm(false)
        setPowerComplaintsToDataGrid([]);
    }

    const onPressClosePending = () => {
        setShowPendingComplaint(false)
    }
    const handleComplaintsFromChild = (complaints) => {
        setOnPressComplaint(complaints)
    };

    const handleSubmitAssign = async () => {
        // const interval = setInterval(async () => {
        setViewBackdrop(true)
        const myHeaders = new Headers();
        myHeaders.append("Authorization", wmsPrivateToken);

        const formdata = new FormData();
        formdata.append("EOpsTrackingId", selectedMarker.complaitData.eOpsTrackingId);
        formdata.append("AllocatedTo", selectedLineman);
        formdata.append("Priority", Priority);
        formdata.append("AllocatedBy", userId);

        setViewBackdrop(true);

        try {
            const response = await fetch(wfsBaseUrl + "api/Complaints/CompaintAllocation", {
                method: "POST",
                headers: myHeaders,
                body: formdata,
            });

            const result = await response.json();
            if (result) {
            }

            dispatch(fetchPaginatedAllComplaints({ pageSize: complaintsPageSize, pageNumber: complaintsPageNumber, subDivisionCode: hierarchy == 52 ? code : '15171', dateFrom: convertDateYYYYMMDD(yesterdayDate), dateTo: convertDateYYYYMMDD(new Date()) }))


            setSelectedMarker("");

            let index = complaints.findIndex(item => item.complaitData.ticketNo === selectedMarker.complaitData.ticketNo);
            if (index !== -1) {
                const updatedComplaints = [...complaints];
                updatedComplaints[index] = {
                    ...updatedComplaints[index],
                    complaitData: {
                        ...updatedComplaints[index].complaitData,
                        status: 'Allocated',
                    },
                };
                setComplaints(updatedComplaints);
            } else {
                console.error('Complaint not found');
            }

            setShowComplaintForm(false);
            setViewBackdrop(false);

            // clearInterval(interval);
        } catch (error) {
            console.error('Error:', error);
            setViewBackdrop(false);
            // clearInterval(interval);
        }
        setViewBackdrop(false)
        // }, 5000);

    };

   


    const { data: allComplaints } = useSelector((state) => state.allComplaints)
    const [circleName, setCircleName] = useState()
    const onClickCircle = (circleName) => {
        setCircleName(circleName.name)
    };

    useEffect(() => {
        if (allComplaints) {

            // const lineComplaint = allComplaints.filter(complaint => complaint.complaitData.complaintNature === "Line Complaints");
            setComplaints(allComplaints);

            const pendingComplaints = allComplaints.filter(
                complaint => (complaint.complaitData.status === 'Pending')
            );

            setPendingComplaints(pendingComplaints.length);

            const allocatedComplaints = allComplaints.filter(
                complaint => (complaint.complaitData.status === 'Allocated')
            );
            setAllocatedComplaints(allocatedComplaints.length);

            const workingComplaints = allComplaints.filter(
                complaint => ((complaint.complaitData.status === 'Working' || complaint.complaitData.status === 'Resume'))
            );
            setWorkingComplaints(workingComplaints.length);

            const onholdComplaints = allComplaints.filter(
                complaint => ((complaint.complaitData.status === 'Onhold' || complaint.complaitData.status === 'onhold'))
            );
            setOnHoldComplaints(onholdComplaints.length);

            const escalatedComplaints = allComplaints.filter(
                complaint => (complaint.complaitData.status === 'Escalated')
            );
            setEscalatedComplaints(escalatedComplaints.length);

            const resolvedComplaints = allComplaints.filter(
                complaint => ((complaint.complaitData.status === 'Resolved' || complaint.complaitData.status === 'resolved'))
            );
            setResolvedComplaints(resolvedComplaints.length);

            let lineComplaints = allComplaints.filter((item) => item.complaitData.complaintNature == "Line Complaints")

            setTotalComplaints(lineComplaints.length)
        }
    }, [allComplaints])

    useEffect(() => {
        dispatch(fetchPaginatedAllComplaints({ pageSize: complaintsPageSize, pageNumber: complaintsPageNumber, subDivisionCode: hierarchy == 52 ? code : '15171', dateFrom: convertDateYYYYMMDD(yesterdayDate), dateTo: convertDateYYYYMMDD(new Date()) }))
        const intervalId = setInterval(() => {
            dispatch(fetchPaginatedAllComplaints({ pageSize: complaintsPageSize, pageNumber: complaintsPageNumber, subDivisionCode: hierarchy == 52 ? code : '15171', dateFrom: convertDateYYYYMMDD(yesterdayDate), dateTo: convertDateYYYYMMDD(new Date()) }))
        }, 60000);
        return () => clearInterval(intervalId);
    }, []);

    const printPDF = () => {
        const headers = ['Complaint ID', 'Ref No.', 'Time', 'Name', 'Address', 'Complaint Type'];
        const headers1 = ["Complaint ID", "Ref No.", "Time", "Name", "Address", "Complaint Type", "Assigned to", "Assigned @"];
        const headers2 = ["Complaint ID", "Ref No.", "Time", "Name", "Address", "Complaint Type", "Holding Reason"];
        const headers3 = ["Complaint ID", "Ref No.", "Time", "Name", "Address", "Complaint Type", "Escalated To"];
        const headers4 = ["Complaint ID", "Ref No.", "Time", "Name", "Address", "Complaint Type", "Resolved By", "Resolved Time"];
        const headers5 = ["Complaint ID", "Ref No.", "Time", "Name", "Address", "Complaint Type", "Last Modification Time"];

        const complaintsData =
            statsValue == '1' ? pendingStats :
                statsValue == '2' ? allocatedStats :
                    statsValue == '3' ? onholdStats :
                        statsValue == '4' ? escalatedStats :
                            statsValue == '5' ? resolvedStats :
                                statsValue == '6' ? allComplaintsState : [];
        ;

        if (!Array.isArray(complaintsData)) {
            console.error("complaintsData is not an array or is undefined.");
            return;
        }

        // Create table body
        const body = complaintsData.map(row => [
            row.eOpsTrackingId,
            row.refNo,
            row.registeredAt,
            row.name,
            row.address,
            row.complaintType
        ]);

        const body1 = complaintsData.map(row => [
            row.eOpsTrackingId,
            row.refNo,
            row.registeredAt,
            row.name,
            row.address,
            row.complaintType,
            row.userFullName,
            row.allocationDateTime
        ]);
        const body2 = complaintsData.map(row => [
            row.eOpsTrackingId,
            row.refNo,
            row.registeredAt,
            row.name,
            row.address,
            row.complaintType,
            row.linemanRemarks
        ]);
        const body3 = complaintsData.map(row => [
            row.eOpsTrackingId,
            row.refNo,
            row.registeredAt,
            row.name,
            row.address,
            row.complaintType,
            row.escalatedTo
        ]);
        const body4 = complaintsData.map(row => [
            row.eOpsTrackingId,
            row.refNo,
            row.registeredAt,
            row.name,
            row.address,
            row.complaintType,

        ]);

        const body5 = complaintsData.map(row => [
            row.eOpsTrackingId,
            row.refNo,
            row.registeredAt,
            row.name,
            row.address,
            row.complaintType,
            row.modificationDateTime
        ]);

        // Create a new jsPDF instance
        const pdf = new jsPDF('landscape', 'mm', 'a4', { compressPdf: true });
        const pageWidth = pdf.internal.pageSize.getWidth();
        const pageHeight = pdf.internal.pageSize.getHeight();

        // Add logos and titles
        pdf.addImage(eOpsLogo, 'PNG', 15, 10, 30, 12.5);
        pdf.setFontSize(10);
        pdf.text(convertDatewithTime(new Date()), pageWidth - 55, 12);
        pdf.text("Name: " + name, pageWidth - 55, 17);
        pdf.text("Designation: " + roleName, pageWidth - 55, 22);

        pdf.setFontSize(12);
        pdf.setFont('helvetica', 'normal');
        pdf.text(`${subdivisionName(hierarchy == 52 ? parseInt(code) : 15171, subDivisions) + " " + `Subdivision - MEPCO`}    `, pageWidth / 2, 12.5, { align: 'center' });
        // pdf.text(' - MEPCO', pageWidth / 2, 12.5, { align: 'center' });

        pdf.setFontSize(16);
        pdf.setFont('helvetica', 'bold');
        pdf.text(`Daily Report - ${statsValue == '1' ? "Pending Complaints" : statsValue == '2' ? "Allocated Complaints" : statsValue == '3' ? "Onhold Complaints" : statsValue == '4' ? "Escalated Complaints" : statsValue == '5' ? "Resolved Complaints" : statsValue == '6' && "Total Complaints"}`, pageWidth / 2, 20, { align: 'center' });

        // Add table to PDF using autoTable
        pdf.autoTable({
            startY: 25,
            head: [statsValue == '1' ? headers : statsValue == '2' ? headers1 : statsValue == '3' ? headers2 : statsValue == '4' ? headers3 : statsValue == '5' ? headers4 : statsValue == '6' && headers5],
            body: statsValue == '1' ? body : statsValue == '2' ? body1 : statsValue == '3' ? body2 : statsValue == '4' ? body3 : statsValue == '5' ? body4 : statsValue == '6' && body5,
            styles: { cellPadding: 1, fontSize: 8 },
            margin: { top: 2 },
            theme: 'striped',
            columnStyles: {
                0: { cellWidth: 30 },
                1: { cellWidth: 30 },
                2: { cellWidth: 40 },
                3: { cellWidth: 50 },
                4: { cellWidth: 50 },
                5: { cellWidth: 40 },
            },
            didDrawPage: function (data) {
                pdf.setFontSize(10);
            },
        });

        pdf.save('complaint_applications_report.pdf');
    };

    const handleMarkerClick = (item) => {
        if (!selectedMarker2) {
            setSelectedMarker2(item);
        }
    };

    useEffect(() => {
        const getData = async () => {
            const myHeaders = new Headers();
            myHeaders.append("Authorization", wmsPrivateToken);

            const formdata = new FormData();

            const requestOptions = {
                method: "POST",
                headers: myHeaders,
                body: formdata,
                redirect: "follow"
            };

            await fetch(wfsBaseUrl + "api/Complaints/GetAllComplaintCatagoriesWithNature", requestOptions)
                .then((response) => response.json())
                .then((result) => {
                    setRemarks(result.Data)
                })
                .catch((error) => console.error(error));
        }
        getData()
    }, [])

    const updateSelectedMarker1 = () => {
        setSelectedMarker2()
    }


    const StatusType = (event) => {
        setStatus(event.target.value);
    };

    const RemarkType = (event) => {
        setRemarkStatus(event.target.value);
    };


    const handleComplaintResolution = async () => {
        const myHeaders = new Headers();
        myHeaders.append("Authorization", wmsPrivateToken);

        const formdata = new FormData();
        formdata.append("status", status);
        formdata.append("linemanRemarks", remarkStatus);
        formdata.append("LinemanAudioRemarks", "");
        formdata.append("LinemanImageRemarks", "");
        formdata.append("ModifiedBy", userId);
        formdata.append("SenderId", "");
        formdata.append("RecipientId", "");
        formdata.append("EOpsTrackingId", selectedMarker.complaitData.eOpsTrackingId);

        const requestOptions = {
            method: "PUT",
            headers: myHeaders,
            body: formdata,
            redirect: "follow"
        };

        await fetch(wfsBaseUrl + "api/Complaints/UpdateStatusWMS", requestOptions)
            .then((response) => response.json())
            .then((result) => {
                if (result.Message == 'Complaint Status updated successfully.') {
                    setShowComplaintForm(false)
                    dispatch(fetchPaginatedAllComplaints({ pageSize: complaintsPageSize, pageNumber: complaintsPageNumber, subDivisionCode: hierarchy == 52 ? code : '15171', dateFrom: convertDateYYYYMMDD(yesterdayDate), dateTo: convertDateYYYYMMDD(new Date()) }))
                }
            })
            .catch((error) => console.error(error));

    }
    const Circles = [
        {
            name: 'Multan',
            pending: '139,193',
            inProcess: '13813',
            resolved: '1000',
            total: '318381831'
        },
        {
            name: 'DG Khan',
            pending: '139,193',
            inProcess: '13813',
            resolved: '1000',
            total: '318381831'
        },
        {
            name: 'Muzafar Garah',
            pending: '139,193',
            inProcess: '13813',
            resolved: '1000',
            total: '318381831'
        },
        {
            name: 'Bahwal Pur',
            pending: '139,193',
            inProcess: '13813',
            resolved: '1000',
            total: '318381831'
        },
        {
            name: 'Sahiwal',
            pending: '139,193',
            inProcess: '13813',
            resolved: '1000',
            total: '318381831'
        },
        {
            name: 'Vehari',
            pending: '139,193',
            inProcess: '13813',
            resolved: '1000',
            total: '318381831'
        },
        {
            name: 'Rahim Yar Khan',
            pending: '139,193',
            inProcess: '13813',
            resolved: '1000',
            total: '318381831'
        },
        {
            name: 'Bahwal Nagar',
            pending: '139,193',
            inProcess: '13813',
            resolved: '1000',
            total: '318381831'
        },
        {
            name: 'Khanewal',
            pending: '139,193',
            inProcess: '13813',
            resolved: '1000',
            total: '318381831'
        },

    ]

    const colorArray = [
        "#c4dfac",
        "#e3c088",
        "#9eecf3",
        "#fdf89a",
        "#d4e2fb",
        "#caf8ff",
        "#b2b5ea",
        "#aad3f0",
        "#fee4e5",
    ];

    function getColor(index) {
        return colorArray[index % colorArray.length]; // Cycle through colors if index exceeds array length
    }
    return (
        <>
            <div className='form-box' style={{ marginTop: '4rem' }} >
                <div style={{ display: 'flex', height: '91vh' }}>
                    <div style={{
                        display: 'flex', flexDirection: 'column', gap: 10, width: '75%', height: '100%', paddingTop: 10, borderRadius: 50
                    }}>
                        <div style={{ flex: 1, visibility: (geoJSON && result1) ? 'visible' : 'hidden' }}>
                            <Map
                                connections={connections} selectedMarker1={selectedMarker2} complaints={complaints} handleSubmit={handleSubmit} onComplaintsUpdate={handleComplaintsFromChild} updateSelectedMarker1={updateSelectedMarker1} />
                        </div>
                        {
                            <div style={{ background: '#003971', width: '99%', height: 30, justifyContent: 'space-between', padding: 10, borderRadius: 8, justifyContent: 'space-between' }}>
                                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', height: '100%' }}>
                                    <div style={{ display: 'flex', alignItems: 'center' }} onClick={() => getDataStats('1')}>
                                        <p style={{ margin: 0, fontSize: 22, color: 'white' }}>Pending : </p>
                                        <p style={{ margin: 0, fontSize: 22, paddingLeft: 2, color: '#FBE451' }}>{pendingComplaints ? pendingComplaints : 0}</p>
                                    </div>
                                    <div style={{ display: 'flex', alignItems: 'center' }} onClick={() => getDataStats('2')}>
                                        <p style={{ margin: 0, fontSize: 22, color: 'white' }}>Allocated : </p>
                                        <p style={{ margin: 0, fontSize: 22, paddingLeft: 2, color: '#FBE451' }}>{allocatedComplaints ? allocatedComplaints : 0}</p>
                                    </div>
                                    <div style={{ display: 'flex', alignItems: 'center' }} onClick={() => getDataStats('2')}>
                                        <p style={{ margin: 0, fontSize: 22, color: 'white' }}>Working : </p>
                                        <p style={{ margin: 0, fontSize: 22, paddingLeft: 2, color: '#FBE451' }}>{workingComplaints ? workingComplaints : 0}</p>
                                    </div>
                                    <div style={{ display: 'flex', alignItems: 'center' }} onClick={() => getDataStats('3')}>
                                        <p style={{ margin: 0, fontSize: 22, color: 'white' }}>On-Hold : </p>
                                        <p style={{ margin: 0, fontSize: 22, paddingLeft: 2, color: '#FBE451' }}>{onholdComplaints ? onholdComplaints : 0}</p>
                                    </div>
                                    <div style={{ display: 'flex', alignItems: 'center' }} onClick={() => getDataStats('4')}>
                                        <p style={{ margin: 0, fontSize: 22, color: 'white' }}>Escalated : </p>
                                        <p style={{ margin: 0, fontSize: 22, paddingLeft: 2, color: '#FBE451' }}>{escalatedComplaints ? escalatedComplaints : 0}</p>
                                    </div>
                                    <div style={{ display: 'flex', alignItems: 'center' }} onClick={() => getDataStats('5')}>
                                        <p style={{ margin: 0, fontSize: 22, color: 'white' }}>Resolved : </p>
                                        <p style={{ margin: 0, fontSize: 22, paddingLeft: 2, color: '#FBE451' }}>{resolvedComplaints ? resolvedComplaints : 0}</p>
                                    </div>
                                    <div style={{ display: 'flex', alignItems: 'center' }} onClick={() => getDataStats('6')} >
                                        <p style={{ margin: 0, fontSize: 22, color: 'white' }}>Total : </p>
                                        <p style={{ margin: 0, fontSize: 22, paddingLeft: 2, color: '#FBE451' }}>{totalComplaints ? totalComplaints : 0}</p>
                                    </div>
                                </div>
                            </div>
                        }

                    </div>

                    {
                        hierarchy == '3' ?

                            <div style={{
                                display: 'flex', flexDirection: 'column', width: '25%', height: '100%',
                            }}>
                                <div style={{
                                    display: 'flex', flexDirection: 'column', width: '100%', height: (counter > 0) ? '80%' : '100%',
                                    color: 'white', alignItems: 'center', overflowY: 'scroll', marginLeft: 10,
                                    marginTop: 10,
                                    borderRadius: 10,
                                    borderWidth: 1,
                                    marginTop: 20
                                }}>
                                    {
                                        complaints &&
                                        complaints.map((item, index) => {
                                            return (
                                                ((item.complaitData.status == 'Pending' || item.complaitData.status == 'Allocated' || item.complaitData.status == 'onhold')) &&
                                                <div
                                                    key={index}
                                                    style={{
                                                        width: '100%',
                                                        backgroundColor: 'white',
                                                        cursor: 'pointer',
                                                        position: 'relative',
                                                        marginBottom: '10px',
                                                    }}
                                                    onClick={() => handleOpenPopup(item)}
                                                    onMouseEnter={() => {
                                                        setHoveredIndex(index);
                                                    }}
                                                    onMouseLeave={() => {
                                                        setHoveredIndex(null);
                                                    }}
                                                >
                                                    <div
                                                        style={{
                                                            display: 'flex',
                                                            backgroundColor:
                                                                (item.complaitData.t1Priority === 'VIP' ||
                                                                    item.complaitData.t1Priority === 'Vip' ||
                                                                    item.complaitData.t1Priority === 'vip')
                                                                    ? '#FCEBEB'
                                                                    : '#D5E5FF',
                                                            margin: '1%',
                                                            padding: '10px',
                                                            borderRadius: '10px',
                                                            alignItems: 'center',
                                                        }}
                                                    >
                                                        <div>
                                                            {item.complaitData.status === 'Pending' ? (
                                                                <img src={redCircle} alt="off" width={15} />
                                                            ) : item.complaitData.status === 'Allocated' ? (
                                                                <img src={orange_Circle} alt="off" width={15} />
                                                            ) : (
                                                                item.complaitData.status === 'onhold' && <img src={orange} alt="off" width={15} />
                                                            )}
                                                        </div>
                                                        <div
                                                            style={{
                                                                paddingLeft: '12px',
                                                                display: 'flex',
                                                                justifyContent: 'space-between',
                                                                width: '100%',
                                                            }}
                                                        >
                                                            <div style={{ width: '33%' }}>
                                                                <p style={{ fontSize: '12px', color: 'black' }}>{item.complaitData.refNo}</p>
                                                            </div>
                                                            <div style={{ width: '33%' }}>
                                                                <p
                                                                    style={{
                                                                        fontSize: '12px',
                                                                        color: 'black',
                                                                        textAlign: 'center',
                                                                    }}
                                                                >
                                                                    {item.complaitData.complaintType}
                                                                </p>
                                                            </div>
                                                            <div style={{ fontSize: '12px', width: '33%' }}>
                                                                <RemainingTime
                                                                    startTime={item.complaitData.registeredAt}
                                                                    fontSize={'12px'}
                                                                />
                                                            </div>
                                                        </div>
                                                        <div>
                                                            {item.complaitData.source === 'eOps' ? (
                                                                <img src={eopsIcons} style={{ width: 25, height: 20 }} />
                                                            ) : item.complaitData.source === 'CCMS' ? (
                                                                <img src={callCenter} style={{ width: 25, height: 20 }} />
                                                            ) : item.complaitData.source === 'Call Center' ? (
                                                                <img src={callCenter} style={{ width: 25, height: 25 }} />
                                                            ) : (
                                                                item.complaitData.source === 'MEPCOSMART' && (
                                                                    <img src={cellIcon} style={{ width: 25, height: 30 }} />
                                                                )
                                                            )}
                                                        </div>
                                                    </div>
                                                    {hoveredIndex === index && (
                                                        <div
                                                            style={{
                                                                position: 'absolute',
                                                                top: '-30px', // Adjust tooltip position
                                                                left: '50%',
                                                                transform: 'translateX(-50%)',
                                                                backgroundColor: '#333',
                                                                color: 'white',
                                                                padding: '5px 10px',
                                                                borderRadius: '5px',
                                                                fontSize: '12px',
                                                                whiteSpace: 'nowrap',
                                                                boxShadow: '0px 2px 5px rgba(0, 0, 0, 0.2)',
                                                                zIndex: 10,
                                                            }}
                                                        >
                                                            {`Status: ${item.complaitData.status == 'Pending' ? "Pending" : item.complaitData.status == 'Allocated' ? "Allocated" : item.complaitData.status == 'onhold' && "OnHold"}`}
                                                        </div>
                                                    )}
                                                </div>

                                            )
                                        })
                                    }
                                </div>
                                <div style={{
                                    display: 'flex', flexDirection: 'column', width: '100%',
                                    color: 'white', alignItems: 'center', overflowY: 'scroll',
                                    backgroundColor: 'white',
                                    borderRadius: 10,
                                    marginLeft: 10,
                                    marginTop: 10
                                }}
                                >
                                    {
                                        connections &&
                                        connections.map((item, index) => {
                                            if (item.contactor_status == 0 && item.kva == 0) {
                                                return (
                                                    <div key={index}
                                                        style={{
                                                            width: '100%',
                                                        }} onClick={() => handleMarkerClick(item)}>
                                                        <div style={{ display: 'flex', backgroundColor: '#d5e5ff', margin: '1%', padding: '10px', borderRadius: '10px' }}>
                                                            <div>
                                                                <img src={triangleoff} alt='off' width={30} />
                                                            </div>
                                                            <div>
                                                                <p style={{ fontSize: '12px', color: 'black' }}>{item.name}</p>
                                                                <p style={{ fontSize: '12px', color: 'black' }}>{item.address}</p>
                                                                <p style={{ fontSize: '12px', color: 'black' }}>{item.last_communication_time}</p>
                                                            </div>
                                                        </div>
                                                    </div>
                                                )
                                            }
                                        })
                                    }
                                </div>
                            </div>

                            :

                            <div style={{
                                display: 'flex', flexDirection: 'column', width: '25%', height: '100%',
                            }}>
                                <div style={{
                                    display: 'flex', flexDirection: 'column', width: '100%', height: (counter > 0) ? '86%' : '100%',
                                    color: 'white', alignItems: 'center', overflowY: 'scroll', marginLeft: 10,
                                    marginTop: 10,
                                    borderRadius: 10,
                                    borderWidth: 1,
                                    marginTop: 20,
                                }}>

                                    {
                                        Circles.map((item, index) => {
                                            return (
                                                <div
                                                    style={{
                                                        width: '100%',
                                                        backgroundColor: 'white',
                                                        cursor: 'pointer',
                                                        position: 'relative',
                                                        marginBottom: '10px',
                                                        borderLeft: `20px solid ${getColor(index)}`,
                                                        borderRadius: 20,
                                                        height: "100%"
                                                    }}
                                                    onClick={() => onClickCircle(item, index)}                                                >
                                                    <div
                                                        style={{
                                                            display: 'flex',
                                                            margin: '1%',
                                                            padding: '10px',
                                                            borderRadius: '10px',
                                                            alignItems: 'center',
                                                        }}
                                                    >


                                                        <div
                                                            style={{
                                                                justifyContent: 'space-between',
                                                                width: '100%',

                                                            }}
                                                        >
                                                            <div style={{ width: '100%', display: 'flex', justifyContent: 'space-between' }}>
                                                                <p style={{ fontSize: '20px', color: 'black' }}>{item.name}</p>
                                                                <p style={{ fontSize: '20px', color: 'red' }}>VIP 20</p>
                                                            </div>

                                                            <div style={{ display: 'flex', justifyContent: 'space-between', marginTop: 10 }}>
                                                                <div>
                                                                    <p style={{ fontSize: '13px', color: 'black', textAlign: 'center', color: '#6A6A6A' }}>Pending</p>
                                                                    <p style={{ fontSize: '18px', color: 'black', textAlign: 'center' }}>10000</p>
                                                                </div>
                                                                <div>
                                                                    <p style={{ fontSize: '13px', color: 'black', textAlign: 'center', color: '#6A6A6A' }}>In Process</p>
                                                                    <p style={{ fontSize: '18px', color: 'black', textAlign: 'center' }}>10000</p>
                                                                </div>
                                                                <div>
                                                                    <p style={{ fontSize: '13px', color: 'black', textAlign: 'center', color: '#6A6A6A' }}>Resolved</p>
                                                                    <p style={{ fontSize: '18px', color: 'black', textAlign: 'center' }}>10000</p>
                                                                </div>
                                                                <div>
                                                                    <p style={{ fontSize: '13px', color: 'black', textAlign: 'center', color: '#6A6A6A' }}>Total</p>
                                                                    <p style={{ fontSize: '18px', color: 'black', textAlign: 'center' }}>10000</p>
                                                                </div>
                                                            </div>

                                                        </div>
                                                    </div>
                                                </div>
                                            )
                                        })
                                    }


                                </div>
                            </div>

                    }

                    {selectedMarker && (
                        <Dialog open={open} onClose={handleClosePopup} maxWidth="md" PaperProps={{
                            style: {
                                borderRadius: '15px',
                                padding: 10
                            }
                        }}>
                            <div onClick={handleClose} style={{ display: 'flex', justifyContent: 'flex-end', marginBottom: 10 }}>
                                <img src={closeIcon} alt='off' width={15} />
                            </div>
                            <div style={{ display: 'grid', gridTemplateColumns: 'auto auto auto auto', gap: 20, backgroundColor: '#d5e5ff', padding: '10px', borderRadius: '10px' }}>
                                <div style={{ height: 'auto' }}>
                                    <p style={{ padding: '5px 0px' }}>Complaint ID: </p>
                                    <p style={{ backgroundColor: 'white', padding: '10px', borderRadius: '5px', border: '1px solid grey' }}>{selectedMarker.complaitData.ticketNo}</p>
                                </div>
                                <div style={{ height: 'auto' }}>
                                    <p style={{ padding: '5px 0px' }}>Ref No.: </p>
                                    <p style={{ backgroundColor: 'white', padding: '10px', borderRadius: '5px', border: '1px solid grey' }}>{selectedMarker.complaitData.refNo}</p>
                                </div>
                                <div style={{ height: 'auto' }}>
                                    <p style={{ padding: '5px 0px' }}>Complaint Type: </p>
                                    <p style={{ backgroundColor: 'white', padding: '10px', borderRadius: '5px', border: '1px solid grey' }}>{selectedMarker.complaitData.complaintType}</p>
                                </div>
                                <div style={{ height: 'auto' }}>
                                    <p style={{ padding: '5px 0px' }}>Registered @: </p>
                                    <p style={{ backgroundColor: 'white', padding: '10px', borderRadius: '5px', border: '1px solid grey' }}>{selectedMarker.complaitData.registeredAt ? convertDatewithTime(selectedMarker.complaitData.registeredAt) : '-'}</p>
                                </div>
                                <div style={{ height: 'auto' }}>
                                    <p style={{ padding: '5px 0px' }}>Applicant Name: </p>
                                    <p style={{ backgroundColor: 'white', padding: '10px', borderRadius: '5px', border: '1px solid grey' }}>{selectedMarker.complaitData.name}</p>
                                </div>
                                <div style={{ height: 'auto' }}>
                                    <p style={{ padding: '5px 0px' }}>Address: </p>
                                    <p style={{ backgroundColor: 'white', padding: '10px', borderRadius: '5px', border: '1px solid grey' }}>{selectedMarker.complaitData.nearByFamousPlace}</p>
                                </div>
                                <div style={{ height: 'auto' }}>
                                    <p style={{ padding: '5px 0px' }}>Phone No.: </p>
                                    <p style={{ backgroundColor: 'white', padding: '10px', borderRadius: '5px', border: '1px solid grey' }}>{selectedMarker.complaitData.mobile}</p>
                                </div>

                                {selectedMarker.complaitData.status === 'Allocated' && (
                                    <>
                                        <div style={{ height: 'auto' }}>
                                            <p style={{ padding: '5px 0px' }}>Assign to:</p>
                                            <p style={{ backgroundColor: 'white', padding: '10px', borderRadius: '5px', border: '1px solid grey' }}>{selectedMarker.allocatedTo.userId}</p>
                                        </div>
                                    </>
                                )}

                                {selectedMarker.complaitData.status === 'Pending' && (
                                    <DialogActions>
                                        <Button variant="contained" onClick={handleSubmit}>Assign</Button>
                                    </DialogActions>
                                )}
                            </div>
                        </Dialog>
                    )}
                </div >
            </div>


            < Dialog
                open={showComplaintForm}
                onClose={() => onClose()}
                fullWidth={true}
                maxWidth="lg"

                className='alert-popups' >
                {/* <DialogTitle sx={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between',textAlign : 'center' }} > */}
                <div style={{ background: 'linear-gradient(180deg, #1DB6E8, #003971)', display: 'flex' }}>
                    <p style={{ textAlign: 'center', width: '100%', color: 'white', display: 'flex', justifyContent: 'center', fontSize: "22px", padding: '20px' }}>
                        {selectedMarker?.complaitData?.status === 'Pending'
                            ? (
                                <div style={{ display: 'flex', }}>
                                    Complaint Allocation

                                </div>
                            )
                            : "Complaint Resolution"
                        }
                    </p>
                    <div style={{ padding: "15px" }}>
                        <img src={closeIconWhite} style={{ width: 20, height: 20, }} onClick={() => setShowComplaintForm(false)} />
                    </div>
                </div>

                <DialogContent style={{ backgroundColor: '#f2f3f5' }} >
                    {
                        selectedMarker &&
                        <>
                            <div style={{ borderRadius: '10px', backgroundColor: '#ffffff', padding: 20 }}>
                                <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                                    <div style={{ width: '19%' }}>
                                        <p style={{ padding: '5px 0px' }}>Complaint ID: </p>
                                        <p style={{ backgroundColor: 'white', padding: '10px', borderRadius: '5px', border: '1px solid grey', height: '20%', backgroundColor: '#f3f4f6' }}>{selectedMarker.complaitData.eOpsTrackingId}</p>
                                    </div>
                                    <div style={{ width: '19%' }}>
                                        <p style={{ padding: '5px 0px' }}>Ref No.: </p>
                                        <p style={{ backgroundColor: 'white', padding: '10px', borderRadius: '5px', border: '1px solid grey', height: '20%', backgroundColor: '#f3f4f6' }}>{selectedMarker.complaitData.refNo}</p>
                                    </div>
                                    <div style={{ width: '19%' }}>
                                        <p style={{ padding: '5px 0px' }}>Applicant Name: </p>
                                        <p style={{ backgroundColor: 'white', padding: '10px', fontSize: 12, borderRadius: '5px', border: '1px solid grey', height: '20%', backgroundColor: '#f3f4f6' }}>{selectedMarker.complaitData.name}</p>
                                    </div>
                                    <div style={{ width: '23%' }}>
                                        <p style={{ padding: '5px 0px' }}>Complaint Type: </p>
                                        <p style={{ backgroundColor: 'white', padding: '10px', fontSize: 12, borderRadius: '5px', border: '1px solid grey', height: '20%', backgroundColor: '#f3f4f6' }}>{selectedMarker.complaitData.complaintType}</p>
                                    </div>
                                    <div style={{ width: '17%' }}>
                                        <p style={{ padding: '5px 0px' }}>Registered @: </p>
                                        <p style={{ backgroundColor: 'white', padding: '10px', borderRadius: '5px', border: '1px solid grey', height: '20%', backgroundColor: '#f3f4f6' }}>{selectedMarker.complaitData.registeredAt ? convertDatewithTime(selectedMarker.complaitData.registeredAt) : '-'}</p>
                                    </div>
                                </div>
                                <div style={{ width: '100%' }}>
                                    <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                                        <div style={{ width: selectedMarker.complaitData.status == 'Allocated' ? "12%" : '19%' }}>
                                            <p style={{ padding: '5px 0px' }}>Phone No.: </p>
                                            <p style={{ backgroundColor: 'white', padding: '10px', borderRadius: '5px', border: '1px solid grey', height: '20%', backgroundColor: '#f3f4f6' }}>{selectedMarker.complaitData.mobile}</p>
                                        </div>
                                        <div style={{ width: selectedMarker.complaitData.status == 'Allocated' ? '52%' : '31%' }}>
                                            <p style={{ padding: '5px 0px' }}>Address: </p>
                                            <p style={{ backgroundColor: 'white', padding: '10px', fontSize: 12, borderRadius: '5px', border: '1px solid grey', height: '20%', backgroundColor: '#f3f4f6' }}>{selectedMarker.complaitData.address}</p>
                                        </div>
                                        {selectedMarker.complaitData.status === 'Allocated' && (
                                            <>
                                                <div style={{ width: '15%' }}>
                                                    <p style={{ padding: '5px 0px' }}>Assign to:</p>
                                                    <p style={{ backgroundColor: 'white', padding: '10px', borderRadius: '5px', border: '1px solid grey', height: '20%', backgroundColor: '#f3f4f6' }}>{selectedMarker.userInfo.userFullName}</p>
                                                </div>
                                                <div style={{ width: '17%' }}>
                                                    <p style={{ padding: '5px 0px' }}>Assign @:</p>
                                                    <p style={{ backgroundColor: 'white', padding: '10px', borderRadius: '5px', border: '1px solid grey', height: '20%', backgroundColor: '#f3f4f6' }}>{convertDatewithTime(selectedMarker.allocatedTo.allocationDateTime)}</p>
                                                </div>

                                            </>
                                        )}

                                        {selectedMarker.complaitData.status != 'Allocated' && (
                                            <>
                                                <div style={{ width: '19%' }}>
                                                    <Typography style={{ padding: '2px 0px' }} className="fieldLabel">Lineman:</Typography>
                                                    <Select style={{ backgroundColor: '#f3f4f6', padding: '10px', borderRadius: '5px', border: '1px solid grey', height: 40 }} onChange={handleLinemanChange} displayEmpty fullWidth>
                                                        <MenuItem value="">Select</MenuItem>
                                                        {userIds.map((item) => (
                                                            <MenuItem value={item.userId} key={item.userId}>{item.userFullName}</MenuItem>
                                                        ))}
                                                    </Select>
                                                </div>

                                                <div style={{ width: '7%' }}>
                                                    <Typography style={{ padding: '2px 0px' }} className="fieldLabel">Priority:</Typography>
                                                    <Select
                                                        style={{ backgroundColor: '#f3f4f6', padding: '10px', borderRadius: '5px', border: '1px solid grey', height: 40 }}
                                                        onChange={handlePriority}
                                                        displayEmpty
                                                        fullWidth
                                                        value={Priority}
                                                    >
                                                        <MenuItem value="1">1</MenuItem>
                                                        <MenuItem value="2">2</MenuItem>
                                                        <MenuItem value="3">3</MenuItem>
                                                        <MenuItem value="4">4</MenuItem>
                                                        <MenuItem value="5">5</MenuItem>
                                                    </Select>
                                                </div>
                                                {
                                                    <>
                                                        <div style={{ marginTop: 27, width: '19%', height: 42 }}>
                                                            <Button variant="contained" sx={{ background: 'linear-gradient(180deg, #1DB6E8, #003971)', width: '100%', height: '100%' }} onClick={handleSubmitAssign}>Allocate</Button>
                                                        </div>
                                                    </>
                                                }
                                            </>
                                        )}
                                    </div>
                                    {/* </form> */}
                                </div>
                                {selectedMarker.complaitData.status == 'Allocated' &&

                                    < div style={{ display: 'flex', }}>
                                        <div style={{ width: '10%' }}>
                                            <p style={{ padding: '5px 0px' }}>Status:</p>
                                            <Select
                                                label="Status"
                                                defaultValue="Resolved"
                                                sx={{
                                                    height: '35px',
                                                    '& .MuiOutlinedInput-root': {
                                                        height: '45px',
                                                    },
                                                    width: '135px'
                                                }}
                                                onChange={StatusType}
                                            >
                                                <MenuItem value="Resolved">Resolved</MenuItem>
                                                <MenuItem value="onhold">Onhold</MenuItem>
                                            </Select>
                                        </div>
                                        {
                                            status === 'Resolved' &&
                                            <div style={{ width: '24%', marginLeft: 30 }}>
                                                <p style={{ padding: '5px 0px' }}>Remarks:</p>
                                                <Select
                                                    label="Status"
                                                    defaultValue="Resolved"
                                                    sx={{
                                                        height: '35px',
                                                        '& .MuiOutlinedInput-root': {
                                                            height: '45px',
                                                        },
                                                        width: '270px',
                                                    }}
                                                    onChange={RemarkType}
                                                >
                                                    {
                                                        remarks.map((item) => {
                                                            return (
                                                                <MenuItem value={item.natureOfComplaint}>{item.natureOfComplaint}</MenuItem>
                                                            )
                                                        })
                                                    }
                                                </Select>


                                            </div>

                                        }

                                        {
                                            status === 'ReAllocate' &&

                                            <div style={{ width: '25%', marginLeft: 30, display: 'flex' }}>
                                                <div>
                                                    <p style={{ padding: '5px 0px' }}>Lineman:</p>
                                                    <Select
                                                        label="Status"
                                                        defaultValue="Lineman"
                                                        sx={{
                                                            height: '35px',
                                                            '& .MuiOutlinedInput-root': {
                                                                height: '45px',
                                                            },
                                                            width: '270px'
                                                        }}
                                                        onChange={handleLinemanChange}
                                                    >
                                                        {userIds.map((item) => (
                                                            <MenuItem value={item.userId} key={item.userId}>{item.userFullName}</MenuItem>
                                                        ))}
                                                    </Select>

                                                </div>

                                            </div>
                                        }


                                        {
                                            remarkStatus === 'Other' &&
                                            <div style={{ marginLeft: 20 }}>
                                                <p style={{ padding: '5px 0px' }}>Other:</p>
                                                <TextField
                                                    variant="outlined"
                                                    sx={{
                                                        height: '35px',
                                                        '& .MuiOutlinedInput-root': {
                                                            height: '35px',
                                                        },
                                                        width: '270px'
                                                    }}
                                                />
                                            </div>
                                        }

                                        <div style={{ marginTop: 27, width: '10%', height: 35, marginLeft: status == 'onhold' ? 30 : 20 }}>
                                            <Button variant="contained" sx={{ background: 'linear-gradient(180deg, #1DB6E8, #003971)', width: '100%', height: '100%' }} onClick={handleComplaintResolution}>
                                                Submit
                                            </Button>
                                        </div>
                                    </div>
                                }

                            </div>
                            {
                                powerComplaintsToDataGrid.length >= 1 &&

                                    selectedMarker.complaitData.status != 'Allocated' ?
                                    <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between', padding: '5px' }}>
                                        <div style={{ flex: 2 }}>
                                            <h3 style={{ color: 'Black', padding: '10px' }}>
                                                Already Allocated Complaints
                                            </h3>
                                            <div className='application-table' style={{ border: '1px solid #ccc', borderRadius: '5px' }}>
                                                <div className='div-datagrid'>
                                                    <BasicTable
                                                        data={powerComplaintsToDataGrid}
                                                        columns={tblColumns}
                                                        sx={tableStyle}
                                                        rowHeight={37.5}
                                                        pageSize={18}
                                                        rowsPerPageOptions={[18, 30, 60]}
                                                        rowsPageOption={false}
                                                        getRowStyle={(params) => {
                                                            return params.indexRelativeToCurrentPage % 2 === 0 ? tableStyle.evenRow : tableStyle.oddRow
                                                        }}
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    :
                                    <></>
                            }
                        </>
                    }
                </DialogContent>
            </Dialog >

            <Dialog
                open={showPendingComplaint}
                onClose={() => onPressClosePending}
                fullWidth={true}
                maxWidth="xl"
                className='alert-popups' >
                <DialogTitle sx={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between' }} className='dialog-title'>
                    {statsValue == '1' ? 'Pending Complaint' : statsValue == '2' ? 'Allocated Complaint' : statsValue == '3' ? 'Onhold Complaint' : statsValue == '4' ? "Escalated Complaint" : statsValue == '5' ? "Resolved Complaint" : statsValue == '6' && "Total Complaint"}
                    <Box sx={{ marginTop: '1%' }} >
                        <PrintIcon sx={{ cursor: 'pointer', color: 'white', marginRight: 5 }} onClick={() => printPDF()} />
                        <CloseIcon id="clearPopup" onClick={() => setShowPendingComplaint(false)} sx={{ color: 'white', cursor: 'pointer' }} />
                    </Box>
                </DialogTitle>
                <DialogContent>
                    <Box className='form-box1'>
                        <div style={{ display: 'flex', flexDirection: "row" }}>
                            <Box className='application-table' style={{ marginRight: '10px' }}>
                                <div className='div-datagrid' >
                                    <div className='reports-container' >
                                        <div className='filter-fields'>

                                        </div>

                                    </div>
                                    <div className="table-container">
                                        <div id="pdf-table">
                                            <table className="table" ref={statsTableRef}>
                                                <thead>
                                                    <tr>
                                                        <th colSpan={statusNames.length + 1} style={{ fontSize: '20px', borderBottom: '2px solid white' }}>
                                                            {subdivisionName(hierarchy == 52 ? parseInt(code) : 15171, subDivisions) + " " + `Subdivision`}
                                                            {" - MEPCO"}
                                                        </th>
                                                    </tr>
                                                    <tr>
                                                    </tr>
                                                </thead>
                                                <Box sx={{}}>
                                                    <Box >
                                                        <div>
                                                            <BasicTable
                                                                data={statsValue == '1' ? pendingStats : statsValue == '2' ? allocatedStats : statsValue == '3' ? onholdStats : statsValue == '4' ? escalatedStats : statsValue == '5' ? resolvedStats : statsValue == '6' && allComplaintsState}
                                                                columns={statsValue == '1' ? tblPendingComplaints : statsValue == '2' ? tblAllocatedComplaints : statsValue == '3' ? tblOnHoldComplaints : statsValue == '4' ? tblEscalatedComplaints : statsValue == '5' ? tblResolvedComplaints : statsValue == '6' && tblTotalComplaints}
                                                                sx={tableStyle}
                                                                rowHeight={37.5}
                                                                pageSize={18}
                                                                rowsPerPageOptions={[18, 30, 60]}
                                                                rowsPageOption={false}
                                                                getRowStyle={(params) => {
                                                                    return params.indexRelativeToCurrentPage % 2 === 0 ? tableStyle.evenRow : tableStyle.oddRow
                                                                }}

                                                            />
                                                        </div>
                                                    </Box>
                                                </Box>
                                            </table>
                                        </div>
                                    </div>
                                </div>
                            </Box>
                        </div>
                    </Box>
                </DialogContent>

            </Dialog >
            < Backdrop
                sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1000 }}
                open={viewBackdrop}
            >
                <CircularProgress color="inherit" />
            </Backdrop >
        </>
    )
}

export default DisplayComplaintsGIS;